'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var DIACRITICS_RANGE_REGEX = /[\u0300-\u036f]/g;
function removeAccents(input) {
  return input.normalize('NFD').replace(DIACRITICS_RANGE_REGEX, '');
}

exports.default = removeAccents;
//# sourceMappingURL=removeAccents.js.map
